import { errorIcon } from '@y42/feature/icons';
import { GoJsModelProperties, GoJsProductColors } from '@y42/gojs';
import { warningIcon } from '@y42/icons';
import { DataLineageNodeTypes } from '@y42/json-schema';
import { Binding, Part, Point, Size } from 'gojs';
import {
  dataLineageButtons,
  DataLineageNodeBinding,
  DataLineageThemeColors,
  DataLineageUINode,
  LINEAGE_PARTS,
} from '../../../../../../state/data-lineage-diagram';

export const logoBinding = () =>
  new Binding('source', '', (node: DataLineageUINode) => {
    return node[DataLineageNodeBinding.DeletedEntity]
      ? errorIcon
      : !node[DataLineageNodeBinding.HasReadPermission]
      ? warningIcon
      : node[DataLineageNodeBinding.Logo];
  });

export const nameBinding = () => new Binding('text', DataLineageNodeBinding.Name);

export const locationBinding = () =>
  new Binding('location', DataLineageNodeBinding.Location, Point.parse).makeTwoWay(Point.stringify);

export const isLayoutPositionedBinding = () =>
  new Binding('isLayoutPositioned', DataLineageNodeBinding.FixedPosition, (x) => !x);

export const zOrderBindings = () => [
  new Binding('layerName', DataLineageNodeBinding.LayerName),
  new Binding('zOrder', DataLineageNodeBinding.ZOrder),
];

// Color Strip Bindings
export const colorStripSizeBinding = () =>
  new Binding('desiredSize', '', (obj) => {
    obj.part.ensureBounds();
    const { height } = obj.actualBounds;

    return new Size(7, height + 2);
  }).ofObject(LINEAGE_PARTS.GROUP_PANEL);

export const colorStripColorBinding = () =>
  new Binding('fill', '', (node: DataLineageUINode, diagramPart: Part) => {
    const hasDarkMode = diagramPart.diagram?.model.modelData[GoJsModelProperties.HasDarkMode];

    const DataLineageNodeTypeToStripColors: Record<DataLineageNodeTypes, string> = {
      [DataLineageNodeTypes.Integration]: hasDarkMode
        ? GoJsProductColors.Dark.Integration
        : GoJsProductColors.Light.Integration,
      [DataLineageNodeTypes.UiModel]: hasDarkMode ? GoJsProductColors.Dark.Model : GoJsProductColors.Light.Model,
      [DataLineageNodeTypes.SqlModel]: hasDarkMode ? GoJsProductColors.Dark.Model : GoJsProductColors.Light.Model,
      [DataLineageNodeTypes.Widget]: hasDarkMode ? GoJsProductColors.Dark.Widget : GoJsProductColors.Light.Widget,
      [DataLineageNodeTypes.Dashboard]: hasDarkMode
        ? GoJsProductColors.Dark.Visualization
        : GoJsProductColors.Light.Visualization,
      [DataLineageNodeTypes.Export]: hasDarkMode ? GoJsProductColors.Dark.Export : GoJsProductColors.Light.Export,
      [DataLineageNodeTypes.DashboardTab]: hasDarkMode
        ? GoJsProductColors.Dark.Visualization
        : GoJsProductColors.Light.Visualization,
      [DataLineageNodeTypes.Empty]: 'transparent',
    };

    return DataLineageNodeTypeToStripColors[node.category];
  });

export const visibleBinding = (binding: DataLineageNodeBinding) => new Binding('visible', binding, Boolean);

export const nameTextBinding = () =>
  new Binding('text', '', (node: DataLineageUINode) => {
    return node[DataLineageNodeBinding.DeletedEntity] ? node.key : node.name;
  });

export const nameTextStrokeBinding = () =>
  new Binding('stroke', GoJsModelProperties.HasDarkMode, (hasDarkMode: boolean) => {
    return hasDarkMode ? DataLineageThemeColors.Dark.Text : DataLineageThemeColors.Light.Text;
  }).ofModel();

export const iconNavFillBinding = () =>
  new Binding('fill', GoJsModelProperties.HasDarkMode, (hasDarkMode: boolean) => {
    return hasDarkMode ? dataLineageButtons.overview.fill.lightMode : dataLineageButtons.overview.fill.darkMode;
  }).ofModel();
